import { Card, Row } from "antd";
import { IPortalDocument } from "../../../types/Documents";
import { Item } from "./Item";
import { useState } from "react";
import { Loader } from "../../../components/Loader";
import { EmptyList } from "./EmtyList";

type ListItemsProps = {
  items: IPortalDocument[];
  isLoading: boolean;
  accountId: string;
};

export const ListItems = ({ items, isLoading, accountId }: ListItemsProps) => {
  const [downloadingItem, setDownloadingItem] = useState<string | undefined>(
    undefined,
  );

  return (
    <Row className="justify-center w-100 py-6 doc-wrapper overflow-y-hidden">
      <Card className="doc-container mx-4 h-100 overflow-y-auto">
        {isLoading ? (
          <Row className="w-100 justify-center h-100">
            <Loader fontSize="64px" />
          </Row>
        ) : (
          <>
            {items.length > 0 ? (
              items.map((item: IPortalDocument) => (
                <Item
                  values={item}
                  key={item.id}
                  downloadingItem={downloadingItem}
                  setDownloadingItem={setDownloadingItem}
                  accountId={accountId}
                />
              ))
            ) : (
              <EmptyList />
            )}
          </>
        )}
      </Card>
    </Row>
  );
};
